import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

Vue.config.productionTip = false

Vue.prototype.$axios = axios.create({
  withCredentials: true
})

const globalMixIn = {
  created() {
    let { title } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = `たくさん集めて！水族館 ${title}`
    }
  }
}

Vue.mixin(globalMixIn);

const store = new Vuex.Store({
  state: {
    loggedIn: false,
    classNum: '',
    stName: '',
    id: '',
    points: '',
    prize: [],
    gachaTimes: 0,
    cardTotal: 0,
    denwaTotal: 0,
    consent: 0,
    age: 0,
    getPrize: '',
    //APIbase: 'http://localhost:8080/',
    //creditCardAPI: 'http://localhost:8081/api.php/',
    APIbase: 'https://link-aid.sakura.ne.jp/aqua_2019/',
    creditCardAPI: 'https://link-aid.sakura.ne.jp/credit/api.php/',
    demwaUse: '',
    creditUse: '',
    effect: '',
    easy: '',
    rateReg: '',
    routeNext: '',
  },
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredAuth)) {
    if (!store.state.loggedIn) {
      next({ path: '/aqua_2019/selectClass' });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiredAuthT)) {
    if (!store.state.loggedIn) {
      next({ path: '/aqua_2019/teacher' });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiredAuthA)) {
    if (!store.state.loggedIn) {
      next({ path: '/aqua_2019/teacher' });
    } else {
      next();
    }
  } else {
    next();
  }
});
